const SvgCube = (props) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <path
      d="M9.143 0h-.285L.5 4.445v8.02L8.828 18h.344l8.328-5.536v-8.02L9.142 0zm6.591 4.781l-2.71 1.441-3.01-1.6 2.709-1.442 3.011 1.601zm-6.733-3.58l2.71 1.44L9 4.082l-2.71-1.44L9.001 1.2zM5.278 3.18l2.71 1.44-3.011 1.601-2.71-1.441 3.011-1.6zM3.991 13.428l-2.357-1.567V9.136l2.357 1.462v2.831zm0-3.95L1.634 8.016V5.72l2.357 1.253v2.506zm4.443 6.903l-3.487-2.317v-2.873l3.487 2.163v3.028zm0-4.146l-3.487-2.163V7.482l3.487 1.854v2.899zm.567-3.874L5.99 6.76 9 5.16l3.011 1.6-3.01 1.6zm4.054 5.703l-3.487 2.317v-3.028l3.487-2.163v2.874zm0-3.992l-3.487 2.163v-2.9l3.487-1.853v2.59zm3.313 1.79l-2.356 1.566v-2.831l2.356-1.462V11.864zm0-3.846L14.012 9.48V6.975l2.356-1.254v2.297z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgCube
